import { toZonedTime } from "date-fns-tz";
import subDays from "date-fns/subDays";

export const getTimeRangeForDays = (days: number) => {
  const now = new Date();

  const endDate = toZonedTime(now, "Asia/Hong_Kong").getTime();
  const startDate = toZonedTime(subDays(now, days), "Asia/Hong_Kong").getTime();

  return {
    endDate,
    startDate,
  };
};
